// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3x85S","list":"BalanceDue_list__3nPnS","listRow":"BalanceDue_listRow__1yWFM","total":"BalanceDue_total__27r6Q"};